import axios from 'axios';

const url = id => `/api/v1/wire/${id}/attachment`;

export function list(id) {
  return axios.get(`${url(id)}s`, { cache: { ignoreCache: true } });
}

export function create(id, file, title) {
  const data = new FormData();
  data.append('attachment', file);

  if (title) {
    data.append('title', title);
  }

  return axios.post(url(id), data, { headers: { 'content-type': 'multipart/form-data' } });
}

export function deleteById(wireId, attachmentId) {
  return axios.delete(`${url(wireId)}/${attachmentId}`);
}
